import * as React from "react";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { filterType } from "../../redux-store/types/api-types";
import { FilterSkeleton } from "../../components/dashboard/chart/CustomePieChart";
import { CustomDropdownBlueIcon } from "../../assets/SvgIcons";
import { useTheme } from "@mui/material";

type FilterProps = {
    options: Array<filterType>,
    defaultValue: number | string,
    IsLoading: boolean,
    setFilterValue?: React.Dispatch<React.SetStateAction<string | number>>
    filterFunction?: (value: string | number) => void
}

export default function CustomDropdown({ options, defaultValue, IsLoading, setFilterValue, filterFunction }: FilterProps) {
    const [value, setValue] = React.useState<string | number>(defaultValue);
    const { palette, typography } = useTheme();

    // console.log('check', defaultValue, options)
    React.useEffect(() => {
        if (defaultValue) {
            setValue(defaultValue)
        }
    }, [defaultValue])

    const handleChange = (event: SelectChangeEvent) => {
        setValue(event.target.value);
        setFilterValue && setFilterValue(event.target.value as string);
        filterFunction && filterFunction(event.target.value as string);
    };

    return (
        <>
            {
                IsLoading ? <FilterSkeleton /> :
                    <Box>
                        {/* <FormControl > */}
                        <Select
                            // labelId="demo-simple-select-label"
                            // id="demo-simple-select"
                            value={value as string}
                            defaultValue={defaultValue as string}
                            onChange={handleChange}
                            sx={{
                                ...typography.body_500,
                                color: palette.primary[500],
                                fontFamily: typography.fontFamily,
                                cursor: 'pointer',
                                padding: "7px 5px",
                                "& .MuiSelect-outlined": {
                                    padding: "0px 7px",
                                },

                                "& .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input": {
                                    paddingRight: "20px",
                                },

                                "&.Mui-focused": {
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        borderWidth: "0",
                                        borderBottom: `1px dashed ${palette.textDark.secondary}`,
                                    },
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderTop: 0,
                                    borderLeft: 0,
                                    borderRight: 0,
                                    marginBottom: 0,
                                    borderBottom: `1px dashed ${palette.textDark.secondary}`,
                                    borderRadius: 0,
                                },
                            }}
                            IconComponent={CustomDropdownBlueIcon}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        padding: "0px 5px",
                                        borderRadius: "12px",
                                        "& .MuiMenuItem-root": {
                                            padding: "6px",
                                            borderRadius: "8px",
                                            ...typography.body_500,
                                            fontFamily: typography.fontFamily,
                                            color: palette.primary[500],
                                            my: 0.4,
                                            "&.Mui-selected": {
                                                backgroundColor: palette.primary[50],
                                                color: palette.primary[500],
                                            },
                                        },
                                        "& .MuiMenuItem-root:hover": {
                                            backgroundColor: palette.primary[50],
                                            color: palette.primary[500],
                                        },
                                    },
                                },
                            }}
                        >
                            {options?.map((data: filterType, key: number) => (
                                <MenuItem key={key as number} value={data.value}>{data.label}</MenuItem>
                            ))}
                        </Select>
                        {/* </FormControl> */}
                    </Box>
            }
        </>

    );
}
